import React from 'react'
import styles from './MicrositeTabSwitcher.module.css'

/**
 * MicrositeTabSwitcher
 * Pill-style tab row for switching between sub-views within a
 * single page — e.g. MicrositeNavigation's Top / Bottom nav tabs.
 * Visually similar to MicrositeStatusFilter but semantically for
 * navigation between distinct forms, not filtering a list.
 *
 * Usage:
 *   <MicrositeTabSwitcher
 *     value={activeTab}
 *     onChange={setActiveTab}
 *     tabs={[
 *       { value: 'top', label: 'Top navigation' },
 *       { value: 'bottom', label: 'Bottom navigation' }
 *     ]}
 *   />
 */
const MicrositeTabSwitcher = ({ value, onChange, tabs = [] }) => (
    <div className={styles.wrap} role="tablist">
        {tabs.map((tab) => (
            <button
                key={tab.value}
                type="button"
                role="tab"
                aria-selected={value === tab.value}
                className={`${styles.tab} ${value === tab.value ? styles.tabActive : ''}`}
                onClick={() => onChange?.(tab.value)}
            >
                {tab.icon}
                {tab.label}
            </button>
        ))}
    </div>
)

export default MicrositeTabSwitcher